<template>
    <div>
        <template v-if="data !== null">
            <div class="">
                <div class="row">
                    <div class="col-md-12">
                        <!-- <p class="mb-3 "> You have been with this company for 2 years & 5 months. </p> -->
                    </div>
                    <div class="col-md-9 dashboard-left">
                        <div class="row top-widgets-row" v-if="last_pay">
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box employee-payroll-counter-box">
                                    <div class="top-box salary">
                                        <span class="normal-text">Current</span>
                                        <p> Salary </p>
                                    </div>
                                    <div class="foot-box clearfix">
                                        <span class="figure float-left" :title="`Rs.${calculateBasic(last_pay.breakUp)}`"> Rs.{{formatAmount( calculateBasic(last_pay.breakUp) )}} </span>
                                        <span class="detail-arrow float-right">
                                            <i class="fas fa-chevron-down"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box employee-payroll-counter-box">
                                    <div class="top-box earning">
                                        <span class="normal-text">Additional</span>
                                        <p> Earnings </p>
                                    </div>
                                    <div class="foot-box clearfix">
                                        <span class="figure float-left" :title="`Rs.${calculateAdditional(last_pay.breakUp)}`"> Rs.{{formatAmount( calculateAdditional(last_pay.breakUp) )}} </span>
                                        <span class="detail-arrow float-right">
                                            <i class="fas fa-chevron-down"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box employee-payroll-counter-box">
                                    <div class="top-box deduction">
                                        <span class="normal-text">Current</span>
                                        <p> Deduction </p>

                                    </div>
                                    <div class="foot-box clearfix">
                                        <span class="figure float-left" :title="`Rs.${calculateDeduction(last_pay.breakUp)}`"> Rs.{{formatAmount( calculateDeduction(last_pay.breakUp) )}} </span>
                                        <span class="detail-arrow float-right">
                                            <i class="fas fa-chevron-down"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box employee-payroll-counter-box">
                                    <div class="top-box net-payment">
                                        <span class="normal-text">Net</span>
                                        <p> Payment </p>

                                    </div>
                                    <div class="foot-box clearfix">
                                        <span class="figure float-left" :title="`Rs.${last_pay.net_salary}`"> Rs.{{formatAmount( last_pay.net_salary )}} </span>
                                        <span class="detail-arrow float-right">
                                            <i class="fas fa-chevron-down"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col charts">
                                <div class="charts-holder">
                                    <div class="chart-head earning-history-head mb-0">
                                        <h2> Earning History </h2>
                                    </div>
                                    <div class="chart-inner payrol-chart">
                                        <div id="container" class="chart"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col">
                                <div class="activity-feed">
                                    <h2> Activity Feed </h2>
                                    <div class="activity-feed-inner">
                                        <div class="activity-feed-box">
                                            <a href="#">
                                                <p> <strong> Hi, </strong>  have applied for <strong>Attendance Correction</strong>  for Thursday 01, Aug 2019.You will be notified once it gets approved by <strong> Shoaib Rehmat </strong> </p>
                                                <span class="activity-feed-date"> 26th January, 2018 12:00 PM </span>
                                            </a>
                                        </div>
                                        <div class="activity-feed-box">
                                            <p> The Accounts Payable Cash Disbursement Procedure explains practices for documenting,  </p>
                                            <span class="activity-feed-date"> 26th January, 2018 12:00 PM </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-md-3 dashboard-right">
                        <div class="dashboard-right-main">
                            <div class="d-right-box employee-profile p-3">
                                <div class="color-strip"></div>
                                <img class="profile-image float-none" :src="'/avatar/'+profile.avatar" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                <h3 class="text-center"> {{profile.name}} </h3>
                                <div class="employee-detail">
                                    <span class="title"> Email </span>
                                    <p :title="profile.email"> {{profile.email}} </p>
                                    <span class="title"> Mobile </span>
                                    <p> {{profile.mobile_no}} </p>
                                    <span class="title"> Status </span>
                                    <p> {{profile.employment_status}} </p>

                                </div>
                            </div>
                            <div class="d-right-box recent-added attendance-review mt-3">
                                <h2> Attendance Review </h2>
                                <div class="recent-added-inner attendance-review-inner" v-if="last_week_attendance.length > 0">
                                    <div class="recent-added-emp-box" v-for="lwa in last_week_attendance" :key="lwa.id">
                                        <p class="emp-detail">
                                            {{lwa.day}}
                                            <span class="added-date">
                                                <i class="far fa-clock"></i> {{lwa.date}}
                                            </span>
                                        </p>
                                        <span :class="`attendance-status ${lwa.class}`"> {{lwa.text}} </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="data === null">
            <preLoader></preLoader>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data:null,
                last_pay : [],
                last_week_attendance:[],
                leaves:[],
                month:[],
                profile:[],
                graph_basic_salary_key:[],
                graph_basic_salary_value:[],
                graph_commission:[],
                graph_reimbursement:[],
                graph_allowance:[],

            };
        },
        filters: {
            dayOnly: function(date){
                return moment(date).format('MMMM');
            }
        },

        mounted() {
            this.$Progress.start();
            this.getMYDashboardData();
        },

        created() {

        },

        updated() {
            $('.detail-arrow').click(function(){
                $(this).toggleClass('open');
                $(this).siblings('.figure').slideToggle()
            })
        },

        methods: {
            getMYDashboardData: function(){
                axios.get('/api/myDashboardData')
                .then(res => {
                    if(res.status == 200){
                        this.data = res.data;
                        this.last_pay = res.data.last_pay;
                        this.last_week_attendance =  res.data.last_week_attendance;
                        this.leaves = res.data.leaves;
                        this.month = res.data.month;
                        this.profile = res.data.profile;
                        var basic_salary = res.data.month.basic_salary;
                        Object.keys(basic_salary).forEach(key=>{
                            this.graph_basic_salary_key.push(key);
                            this.graph_basic_salary_value.push(parseInt(basic_salary[key]));
                        });
                        var graph_commission = res.data.month.commission;
                        Object.keys(graph_commission).forEach(key=>{
                            this.graph_commission.push(parseInt(graph_commission[key]));
                        });
                        var reimbursement = res.data.month.reimbursement;
                        Object.keys(reimbursement).forEach(key=>{
                            this.graph_reimbursement.push(parseInt(reimbursement[key]));
                        });
                        var allowance = res.data.month.allowance;
                        Object.keys(allowance).forEach(key=>{
                            this.graph_allowance.push(parseInt(allowance[key]));
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }

                })
                .then(res => {
                    this.hightChartGraph();
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },
            calculateBasic:function(breakUp){
                if(breakUp){
                    var obj = JSON.parse(breakUp);
                    let basic_salary = 0;
                    if(obj.hasOwnProperty('basic_salary') && obj.basic_salary !== '') basic_salary += parseInt(obj.basic_salary);
                    if(obj.hasOwnProperty('housing_allowance') && obj.housing_allowance !== '') basic_salary += parseInt(obj.housing_allowance);
                    if(obj.hasOwnProperty('medical_allowance') && obj.medical_allowance !== '') basic_salary += parseInt(obj.medical_allowance);
                    if(obj.hasOwnProperty('car_allowance') && obj.car_allowance !== '') basic_salary += parseInt(obj.car_allowance);
                    if(obj.hasOwnProperty('fuel_allowance') && obj.fuel_allowance !== '') basic_salary += parseInt(obj.fuel_allowance);
                    if(obj.hasOwnProperty('other_allowance') && obj.other_allowance !== '') basic_salary += parseInt(obj.other_allowance);
                    return basic_salary;
                }
            },
            calculateAdditional:function(breakUp){
                if(breakUp){
                    var obj = JSON.parse(breakUp);
                    let additional_earning = 0;
                    if(obj.hasOwnProperty('overtime') && obj.overtime !== '') additional_earning += parseInt(obj.overtime);
                    if(obj.hasOwnProperty('bonus') && obj.bonus !== '') additional_earning += parseInt(obj.bonus);
                    if(obj.hasOwnProperty('commission') && obj.commission !== '') additional_earning += parseInt(obj.commission);
                    if(obj.hasOwnProperty('other_additional_earning') && obj.other_additional_earning !== '') additional_earning += parseInt(obj.other_additional_earning);
                    if(obj.hasOwnProperty('fuelreimbursement') && obj.fuelreimbursement !== '') additional_earning += parseInt(obj.fuelreimbursement);
                    if(obj.hasOwnProperty('travelingreimbursement') && obj.travelingreimbursement !== '') additional_earning += parseInt(obj.travelingreimbursement);
                    if(obj.hasOwnProperty('reimbursements') && obj.reimbursements !== '') additional_earning += parseInt(obj.reimbursements);

                    return additional_earning;
                }
            },
            calculateDeduction:function(breakUp){
                if(breakUp){
                    var obj = JSON.parse(breakUp);
                    let salary = 0;
                    if(obj.hasOwnProperty('income_tax') && obj.income_tax !== '') salary += parseInt(obj.income_tax);
                    if(obj.hasOwnProperty('eobi') && obj.eobi !== '') salary += parseInt(obj.eobi);
                    if(obj.hasOwnProperty('provident_fund') && obj.provident_fund !== '') salary += parseInt(obj.provident_fund);
                    if(obj.hasOwnProperty('other_deduction') && obj.other_deduction !== '') salary += parseInt(obj.other_deduction);
                    if(obj.hasOwnProperty('outstanding_advance_salary') && obj.outstanding_advance_salary !== '') salary += parseInt(obj.outstanding_advance_salary);
                    if(obj.hasOwnProperty('fees_advance_salary') && obj.fees_advance_salary !== '') salary += parseInt(obj.fees_advance_salary);

                    return salary;
                }
            },

            hightChartGraph: function(){

                Highcharts.chart('container', {
                    chart: {
                        type: 'column',
                        style: {
                            fontFamily: 'Raleway',
                            borderWidth: 0,
                            align: 'right',
                        }
                    },
                    legend:{
                        itemStyle: {
                            fontSize:'10px',
                            fontWeight: '600',
                            color: '#686868'
                        },
                        verticalAlign: 'top',
                        align:'right',
                        y: -13,
                        x: -15,
                        itemMarginTop: 10,
                        itemMarginBottom: 10,
                        itemMarginLeft: 0,
                        itemMarginRight: 0,

                    },
                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            y: 0
                        },

                    },
                    credits: false,
                    title: {
                        text: null,
                        align: 'left',
                        x: 0,
                        y: 17,
                    },
                    xAxis: {
                        categories: this.graph_basic_salary_key,
                        style: {
                            fontFamily: 'Raleway'
                        }
                    },
                    yAxis: {
                        min: 0,
                        style: {
                            fontFamily: 'Raleway'
                        },
                        title: {
                            text: null
                        }
                    },
                    tooltip: {
                        pointFormat: '<span style="color:#282828;"> <b>Rs. {point.y:.0f}</span></b> {series.name}<br/>',
                        backgroundColor: '#fff',
                        borderColor: '#e0e6e0',
                        borderRadius: 8,
                        borderWidth: 1,
                        shadow: false,
                        headerFormat: '',
                        style: {
                            opacity: 1
                        }
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0,
                            borderWidth: 0
                        }
                    },
                    series: [{
                        name: 'Basic Salary',
                        data: this.graph_basic_salary_value,
                        color: '#e9488a',
                        borderColor: 'black',
                        borderWidth: 0,
                        style: {
                            fontFamily: 'Raleway'
                        }
                    }, {
                        name: 'Commission',
                        data: this.graph_commission,
                        color: '#fbb06a',
                        borderWidth: 0,
                    }, {
                        name: 'Reimbursment',
                        data: this.graph_reimbursement,
                        color: '#b2d68d',
                        borderWidth: 0,
                    }, {
                        name: 'Allowance',
                        data: this.graph_allowance,
                        color: '#fd9f28',
                        borderWidth: 0,
                    }
                    // , {
                    //     name: 'All Other Facilites',
                    //     data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5],
                    //     color: '#d8dfe4',
                    //     borderWidth: 0,
                    // }
                    ]
                });
            }
        }
    }
</script>
